<template>
   <div>
      <template v-if="showNewEffortForm == true || onlyForm == true">
         <div class="col-sm-12">
            <vs-divider color="primary" position="left">
               <h5 class="bold">Contacto con:</h5>
            </vs-divider>
            <div class="vx-row">
               <div class="vx-col md:w-1/6 sm:w-full w-full mb-3" v-for="contact in contactOptions"
                  :key="contact.value">
                  <rg-radio class="w-full" groupName="contact" :label="contact.label" :value="contact.value"
                     v-model.lazy="currentContact" />
               </div>
            </div>
            <vs-divider color="primary" position="left">
               <h5 class="bold">Medio de contacto:</h5>
            </vs-divider>
            <div class="vx-row">
               <div class="vx-col md:w-1/6 sm:w-full w-full mb-3" v-for="way in contactWayOptions" :key="way.value">
                  <rg-radio class="w-full" groupName="way" :label="way.label" :value="way.value"
                     v-model="currentContactWay" />
               </div>
            </div>
            <vs-divider color="primary" position="left">
               <h5 class="bold">Se logra contacto:</h5>
            </vs-divider>
            <div class="vx-row">
               <div class="vx-col md:w-1/2 sm:w-full w-full mb-3" v-for="contact in contactMadeOptions"
                  :key="contact.value">
                  <rg-radio class="w-full" groupName="contact-made" :label="contact.label" :value="contact.value"
                     v-model="currentContactMade" />
               </div>
            </div>
            <template v-if="resultsOptionsFiltered.length > 0">
               <vs-divider color="primary" position="left">
                  <h5 class="bold">Resultado:</h5>
               </vs-divider>
               <div class="vx-row">
                  <div :class="colClass" v-for="result in resultsOptionsFiltered" :key="result.value">
                     <rg-radio class="w-full" groupName="result" :label="result.label" :value="result.value"
                        v-model="currentResult" />
                  </div>
               </div>
            </template>
            <div class="vx-row mt-5">
               <vs-divider color="primary" position="center">
                  <h5 class="bold">Comentario interno (opcional):</h5>
               </vs-divider>
               <div class="col-md-12">
                  <textarea maxlength="255" rows="5" name="description" placeholder="Escribe un comentario" class="form-control" v-model="description"></textarea>
               </div>
            </div>
         </div>
         <div v-if="currentResult == 'ptp'" class="col-sm-12">
            <vs-divider color="primary" position="center">
               <h5 class="bold">Promesa de pago</h5>
            </vs-divider>
            <div class="vx-row">
               <div class="col-md-6">
                  <label class="bold">Fecha:</label>
                  <datepicker placeholder="Fecha" :language="es" v-model="promiseDate" format="dd/MM/yyyy"
                     :disabledDates="disabledDates" />
               </div>
               <div class="col-md-6">
                  <label class="bold">Monto:</label>
                  <vs-input class="w-full" type="text" v-model="promiseAmountMoney" v-money="money"
                     name="promiseAmountMoney" v-validate="'required'" :min="1" icon-pack="feather"
                     icon="icon-dollar-sign" autocomplete="off" placeholder="Monto" />
               </div>
            </div>
         </div>
         <div class="col-md-12 mb-base">
            <div class="flex justify-end mt-base">
               <vs-button :disabled="!currentResult" color="success" class="mt-6"
                  @click="saveCollectionEffort()">Guardar</vs-button>
            </div>
         </div>
      </template>
      <template v-else>
         <div v-if="requestMade">
            <div class="vx-row">
               <div class="vx-col md:w-1/2 sm:w-full w-full mb-3">
                  <vs-button color="success" size="small" @click="newCollectionEffort()">Agregar Gestión</vs-button>
               </div>
               <div v-if="allCollectionEfforts.projects.length > 1" class="vx-col md:w-1/2 sm:w-full w-full mb-3">
                  <label class="bold">Proyectos relacionados:</label>
                  <vs-col v-for="(project, index) in allCollectionEfforts.projects" :key="index">
                     <label color="success" class="mb-2">{{ project.alias }} (PID: <b>{{ project.project_id
                           }}</b>)</label>
                  </vs-col>
               </div>
            </div>
            <vs-table class="mt-2" :data="allCollectionEfforts.efforts" noDataText="No hay datos disponibles">
               <template slot="thead">
                  <vs-th>Fecha</vs-th>
                  <vs-th>Persona</vs-th>
                  <vs-th>Medio</vs-th>
                  <vs-th>Contacto</vs-th>
                  <vs-th>Resultado</vs-th>
                  <vs-th>Comentario interno</vs-th>
               </template>
               <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                     <vs-td>{{ dateTime12Format(tr.created_at) }}</vs-td>
                     <vs-td>{{ tr.contact_person }}</vs-td>
                     <vs-td>{{ tr.contact_way }}</vs-td>
                     <vs-td>{{ booleanFormat(tr.contact_made) }}</vs-td>
                     <vs-td>{{ tr.effort_result }}</vs-td>
                     <vs-td>{{ tr.description }}</vs-td>
                  </vs-tr>
               </template>
            </vs-table>
         </div>
      </template>
   </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import RgRadio from "@components/misc/RgRadio.vue";
import { VMoney } from 'v-money'
import currencyHelper from "@mixins/currencyHelper";

export default {
   name: "CollectionEfforts",
   props: ["onlyForm", "projectId"],
   mixins: [formatHelper, dateHelper, currencyHelper],
   directives: { money: VMoney },
   components: {
      Datepicker,
      RgRadio
   },
   data() {
      return {
         es: es,
         loading: false,
         allCollectionEfforts: [],
         requestMade: false,
         showNewEffortForm: false,
         colClass: "vx-col md:w-1/5 sm:w-full w-full mb-3",
         currentContact: null,
         contactOptions: [
            { value: 'titular', label: "Titular" },
            { value: 'familiar', label: "Familiar" },
            { value: 'referencia', label: "Referencia" },
            { value: 'os', label: "Obligado Solidario" },
            { value: 'rep_legal', label: "Rep. Legal" },
            { value: 'tercero', label: "Tercero" }
         ],
         currentContactWay: null,
         contactWayOptions: [
            { value: 'whatsapp', label: "WhatsApp" },
            { value: 'call', label: "Llamada" },
            { value: 'sms', label: "SMS" },
            { value: 'email', label: "Email" },
            { value: 'visit', label: "Visita domiciliaria" },
            { value: 'legal', label: "Cobranza legal" }

         ],
         currentContactMade: null,
         contactMadeOptions: [
            { value: '1', label: "Sí" },
            { value: '0', label: "No" },
         ],
         currentResult: null,
         promiseDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
         ),
         disabledDates: {
            to: new Date(),
         },
         promiseAmountMoney: this.currencyFormat(0),
         description: null,
         money: {
            decimal: '.',
            thousands: ',',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
         }
      };
   },
   watch: {
      currentContactMade: function () {
         this.currentResult = null;
      },
      currentResult: function () {
         this.description = null;
      }
   },
   async mounted() {
      if (!this.onlyForm) {
         await this.getCollectionEfforts();
      }
   },
   computed: {
      resultsOptionsFiltered() {
         let results = [];
         if (!this.currentContact || !this.currentContactWay || !this.currentContactMade) {
            return results;
         }
         if (this.currentContactMade == 1) {
            results = [
               { value: "negativa_pago", label: "NEGATIVA DE PAGO" },
               { value: "en_seguimiento", label: "EN SEGUIMIENTO" },
               { value: "numero_equivocado", label: "NÚMERO EQUIVOCADO" },
               { value: "carta_tercero", label: "SE DEJA CARTA A TERCERO" },
               { value: "en_negociacion", label: "EN NEGOCIACION" },
               { value: "mensaje_tercero", label: "MENSAJE CON TERCERO" },
               { value: "cambio_domicilio", label: "CAMBIO DE DOMICILIO" },
               { value: "aclaracion", label: "ACLARACION" },
            ];
            if (this.currentContact != "familiar" && this.currentContact != "referencia") {
               results.unshift({ value: "ptp", label: "PTP" });
            }
         } else {
            switch (this.currentContactWay) {
               case "whatsapp":
                  results = [
                     { value: "wpp_sin_responder", label: "WPP SIN RESPONDER" },
                     { value: "wpp_bloqueado", label: "WPP BLOQUEADO" }
                  ];
                  break;
               case "call":
                  results = [
                     { value: "telefono_inexistente", label: "TELÉFONO INEXISTENTE" },
                     { value: "envia_buzon_directo", label: "ENVIA A BUZON DIRECTO" },
                     { value: "llamadas_sin_responder", label: "LLAMADA SIN RESPONDER" },
                     { value: "llamadas_restringidas", label: "LLAMADAS RESTRINGIDAS" },
                  ];
                  break;
               case "sms":
                  results = [
                     { value: "telefono_inexistente", label: "TELÉFONO INEXISTENTE" },
                     { value: "mensaje_sin_responder", label: "MENSAJE SIN RESPONDER" },
                     { value: "telefono_bloqueado", label: "TELÉFONO BLOQUEADO" },
                  ];
                  break;
               case "email":
                  results = [
                     { value: "correo_sin_respuesta", label: "CORREO SIN RESPUESTA" }
                  ];
                  break;
               case "visit":
                  results = [
                     { value: "domicilio_cerrado", label: "DOMICILIO CERRADO" },
                     { value: "domicilio_incorrecto", label: "DOMICILIO INCORRECTO" },
                     { value: "domicilio_deshabitado", label: "DOMICILIO DESHABITADO" }
                  ];
                  break;
               case "legal":
                  results = [
                     { value: "notificacion_vencimiento", label: "NOTIFICACION DE VENCIMIENTO ANTICIPADO" },
                     { value: "inicio_judicial", label: "INICIO DE PROCESO JUDICIAL MERCANTIL" },
                     { value: "judicial_curso", label: "PROCESO JUDICIAL EN CURSO" },
                     { value: "judicial_sentencia", label: "PROCESO JUDICIAL EN CURSO-SENTENCIA" },
                     { value: "ejecucion_forzosa", label: "EJECUCION FORZOSA" },
                     { value: "recuperacion_garantia", label: "RECUPERACION DE GARANTIA" },
                     { value: "conclusion_recuperacion", label: "CONCLUSION PROCESO-RECUPERACION ADEUDO" },
                     { value: "conclusion_irrecuperable", label: "CONCLUSION PROCESO-IRRECUPERABLE" }
                  ];
                  break;
               default:
                  break;
            }

         }
         return results;
      }
   },
   methods: {
      async getCollectionEfforts() {
         await this.geteEfforts();
      },
      onSelect({ dialCode }) {
         this.countryCallingCode = `+${dialCode}`
      },
      async geteEfforts() {
         this.resetValues();
         this.showLoading(true);
         this.requestMade = false;
         await axios
            .post("/api/cobranza/get-collection-efforts", {
               project_id: this.projectId,
            })
            .then((response) => {
               this.allCollectionEfforts = response.data;
               this.requestMade = true;
            })
            .catch((error) => {
               this.requestMade = false;
               if (error.response.data.message !== undefined) {
                  this.errorNotif("Aviso", error.response.data.message, 4000);
               } else {
                  this.errorNotif(
                     "Aviso",
                     "Ha ocurrido un error intente mas tarde.",
                     4000
                  );
               }
            });
         this.requestMade = true;
         this.showLoading(false);
      },
      newCollectionEffort() {
         this.currentContact = null;
         this.currentContactMade = null;
         this.currentContactWay = null;
         this.currentResult = null;
         this.showNewEffortForm = true;
      },
      async saveCollectionEffort() {
         let result = this.$validator.validateAll();
         if (!result) {
            return;
         }
         let amount = this.unMoneyFormat(this.promiseAmountMoney);
         if (this.currentResult == "ptp") {
            if (amount <= 0) {
               this.errorNotif("Aviso", "Por favor ingresa un monto válido.",4000);
               return;
            }
         }
         this.showLoading(true);
         await axios.post("/api/cobranza/save-collection-effort", {
            project_id: this.projectId,
            contact: this.currentContact,
            made: this.currentContactMade,
            way: this.currentContactWay,
            result: this.currentResult,
            promise_date: this.promiseDate,
            promise_amount: amount,
            description: this.description,
         })
         .then(async (response) => {
            this.resetValues();
            // await this.geteEfforts();
            // this.showNewEffortForm = false;
            // this.onlyForm = false;
            this.successNotif("Aviso", "Gestión guardada exitosamente", 4000);
            this.showLoading(false);
            this.$emit('updated', 1);
         })
         .catch((error) => {
            this.showLoading(false);
            if(error.response.data.message != undefined){
               this.errorNotif("Aviso", error.response.data.message, 4000);
            }else{
               this.errorNotif("Aviso", 'Ha ocurrido un error, intente más tarde', 4000);
            }
         });
      },
      hasError(val) {
         return this.errors.has(val)
      },
      errorText(val) {
         return this.errors.first(val)
      },
      isSuccess(val) {
         let ff = this.fields[val]
         return ff && ff.required && ff.valid
      },
      resetValues() {
         this.description = null;
         this.promiseAmountMoney = this.currencyFormat(0);
         this.promiseDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
         );
         this.currentContact = null;
         this.currentContactMade = null;
         this.currentContactWay = null;
         this.currentResult = null;
         this.allCollectionEfforts = [];
      },
   },
};
</script>